import { Box, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";
import { useTheme } from "@emotion/react";
import { AuthContext } from "../../../../../context/AuthContext";
import QuotePreview from "./QuotePreview";

const QuoteDetailsPage = () => {
  const { quoteId } = useParams();
  const theme = useTheme();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { ezorder, authToken } = useContext(AuthContext);
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState();

  const authHeader = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };

  const getQuoteById = async (id) => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/admin/orders/${id}`, authHeader);
      if (response.status === 200 || response.status == 201) {
        setQuote(response.data.order);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (quoteId) {
      // quoteId is not null. Load the order and set it as quote detail
      getQuoteById(quoteId);
    }
  }, [quoteId]);

  if (quote) {
    return (
      <Box>
        <QuotePreview
          quote={quote}
          onQuoteUpdated={() => {
            // refresh
            getQuoteById(quoteId);
          }}
        />
      </Box>
    );
  } else {
    return <Box>Not Found</Box>;
  }
};

export default QuoteDetailsPage;
